import {Component} from "@angular/core";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {IntegratedInstanceSearchModel} from "../integrated-instance-search.model";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";
import {IntegratedInstanceEntityModel} from "../integrated-instance-entity.model";

@Component({
    selector: "wbo-integrated-instance-search-page",
    templateUrl: "./integrated-instance-search-page.component.html",
    providers: [
        provideSearchModel(IntegratedInstanceSearchModel),
        provideEntityModel(IntegratedInstanceEntityModel)
    ]
})
export class IntegratedInstanceSearchPageComponent extends AbstractSearchPage {
}
